import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { ServiceFormItem , serviceStatusEnum, serviceTypeEnum } from '../../contactSchema';
import { defaultFormValues } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const TYPE_OPTIONS = [
  { value: '', label: '—' },
  { value: 'subscription' as const, label: 'Subscription' },
  { value: 'one-time' as const, label: 'One-time' },
  { value: 'recurring' as const, label: 'Recurring' },
] satisfies { value: (typeof serviceTypeEnum.options)[number]; label: string }[];

const STATUS_OPTIONS = [
  { value: '', label: '—' },
  { value: 'active' as const, label: 'Active' },
  { value: 'expired' as const, label: 'Expired' },
  { value: 'cancelled' as const, label: 'Cancelled' },
] satisfies { value: (typeof serviceStatusEnum.options)[number]; label: string }[];

const empty = (): ServiceFormItem => ({ serviceName: '' });

export const ServicesSection = withForm({
  defaultValues: defaultFormValues,
  render: function ServicesSection({ form }) {
    return (
      <SectionCard
        title="Services"
        actions={<AddItemButton onClick={() => form.pushFieldValue('services', empty())} />}
      >
        <form.AppField name="services">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove service">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`services[${i}].serviceName`}>
                        {(f) => <f.TextField label="Service name" required />}
                      </form.AppField>
                      <form.AppField name={`services[${i}].type`}>
                        {(f) => <f.Select label="Type" options={TYPE_OPTIONS} />}
                      </form.AppField>
                      <form.AppField name={`services[${i}].status`}>
                        {(f) => <f.Select label="Status" options={STATUS_OPTIONS} />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`services[${i}].purchasedOn`}>
                        {(f) => <f.DatePicker label="Purchased on" />}
                      </form.AppField>
                      <form.AppField name={`services[${i}].expiresOn`}>
                        {(f) => <f.DatePicker label="Expires on" />}
                      </form.AppField>
                    </div>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
